const getTransactionType = (transaction) => {
  const selectedData = transaction?.data || transaction?.metadata;

  if (transaction.paymentType) {
    return transaction.paymentType;
  }

  if (transaction.type) {
    return transaction.type;
  }

  if (selectedData) {
    let typeKey = Object.keys(selectedData)?.filter((elem) =>
      elem?.startsWith("type")
    );
    if (typeKey.length > 0) {
      return selectedData?.[typeKey[0]];
    }
  }
  return null;
};

export { getTransactionType };
